import { EarlyAccessCreateUserTypes } from './types';

/**
 * Sets the first name for the Early Access create user form
 * @param {string} firstName - The user's first name
 * @returns {Object} Action object with type and firstName
 */
export const setEarlyAccessCreateUserFirstName = firstName => ({
  type: EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_FIRST_NAME,
  firstName,
});

/**
 * Sets the last name for the Early Access create user form
 * @param {string} lastName - The user's last name
 * @returns {Object} Action object with type and lastName
 */
export const setEarlyAccessCreateUserLastName = lastName => ({
  type: EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_LAST_NAME,
  lastName,
});

/**
 * Sets the username for the Early Access create user form
 * @param {string} username - The user's chosen username
 * @returns {Object} Action object with type and username
 */
export const setEarlyAccessCreateUserUsername = username => ({
  type: EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_USERNAME,
  username,
});

/**
 * Sets the password for the Early Access create user form
 * @param {string} password - The user's chosen password
 * @returns {Object} Action object with type and password
 */
export const setEarlyAccessCreateUserPassword = password => ({
  type: EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_PASSWORD,
  password,
});

/**
 * Sets the associated schools for the Early Access create user form
 * @param {Array} associatedSchools - The schools associated with the user
 * @returns {Object} Action object with type and associatedSchools
 */
export const setEarlyAccessCreateUserAssociatedSchools = associatedSchools => ({
  type:
    EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_ASSOCIATED_SCHOOLS,
  associatedSchools,
});

/**
 * Sets the current step in the Early Access create user form
 * @param {number} earlyAccessCreateUserStep - The step number
 * @returns {Object} Action object with type and earlyAccessCreateUserStep
 */
export const setEarlyAccessCreateUserStep = earlyAccessCreateUserStep => ({
  type: EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_STEP,
  earlyAccessCreateUserStep,
});

export const setEarlyAccessCreateUserLoading = () => ({
  type: EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_REQUEST_IS_LOADING,
});

export const setEarlyAccessCreateUserError = () => ({
  type: EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_REQUEST_HAS_ERROR,
});

export const setEarlyAccessCreateUserSuccess = () => ({
  type: EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_REQUEST_IS_SUCCESS,
});

/**
 * Sets the email for the Early Access create user form
 * @param {string} email - The user's email address
 * @returns {Object} Action object with type and email
 */
export const setEarlyAccessCreateUserEmail = email => ({
  type: EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_EMAIL,
  email,
});

/**
 * Sets the primary (default) school for the Early Access create user form
 * @param {Object|null} defaultSchool - The school chosen as primary
 * @returns {Object} Action object with type and defaultSchool
 */
export const setEarlyAccessCreateUserDefaultSchool = defaultSchool => ({
  type:
    EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_DEFAULT_SCHOOL,
  defaultSchool,
});
